import service from "@/api/service";
import { GetResponse } from "@/api/shop-ticket/response";
import { SearchRequest } from "@/api/shop-ticket/request";
import { SearchResponse } from "@/api/shop-ticket/response";

/**
 * デジタルチケット店舗情報取得APIをコールします。
 *
 * @param searchRequest 検索のリクエストボディ
 * @return SearchResponse
 */
export async function search(searchRequest: SearchRequest) {
  const response = await service.post("/search-ticket-shop", searchRequest);
  return response.data as SearchResponse;
}

/**
 * デジタルチケット店舗一覧検・検索APIをコールします。
 *
 * @return GetResponse
 */
export async function get() {
  const response = await service.post("/get-ticket-shop");
  return response.data as GetResponse;
}
